/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';
import { costCalculatorGetResponseSchema } from './costCalculatorGetResponseSchema.ts';

/**
 * @description 200 response
 */
export const getCostCalculator200Schema = z.lazy(() => costCalculatorGetResponseSchema);

/**
 * @description 505 response
 */
export const getCostCalculator505Schema = z.any();

export const getCostCalculatorQueryResponseSchema = z.lazy(() => getCostCalculator200Schema);
